import React, { JSX } from "react";
import { ArrowDownStroke } from "@/components/assets/icons";
import classNames from "classnames";
import { Button } from "../button/button";
import { useFormikContext } from "formik";
import { useTranslations } from "next-intl";

interface TSelectForm {
  additionalFormButtonText?: string;
  onShowList: () => void;
  children?: JSX.Element;
}

const SelectForm = ({
  additionalFormButtonText,
  onShowList,
  children,
}: TSelectForm) => {
  const { handleSubmit } = useFormikContext();
  const t = useTranslations();

  return (
    <div>
      <div className="flex items-center gap-2 p-[7px] pb-[6px]">
        <div
          className="flex h-[38px] w-[38px] cursor-pointer items-center justify-center rounded-full bg-[#f9f9f9]"
          onClick={onShowList}
        >
          <ArrowDownStroke />
        </div>
        <p className="text-sm font-medium uppercase opacity-30">
          {additionalFormButtonText || "Add new"}
        </p>
      </div>
      <div className="px-[15px]">
        <div className="flex flex-col gap-[10px]">{children}</div>
      </div>
      <div
        className={classNames(
          "border-top sticky bottom-0 mt-[15px] w-full border-t-[1px] border-[#f3f3f3] bg-white p-[15px]",
        )}
      >
        <Button
          type={"button"}
          onClick={() => {
            handleSubmit();
          }}
        >
          {t("add_new_address")}
        </Button>
      </div>
    </div>
  );
};

export { SelectForm };
